export enum TimePeriodComparisonType {
  fullPeriod = "fullPeriod",
  partialPeriod = "partialPeriod"
}

export enum TimePeriodComparisonName {
  fullPeriod = "Full Period",
  partialPeriod = "Partial Period"
}

export enum TimePeriodType {
  today = "today",
  tomorrow = "tomorrow",
  yesterday = "yesterday",
  thisWeek = "thisWeek",
  lastWeek = "lastWeek",
  thisMonth = "thisMonth",
  lastMonth = "lastMonth",
  selectDate = "selectDate",
  fourWeeks = "fourWeeks",
  sixMonths = "sixMonths",
  custom = "custom",
  noEndDate = "noEndDate"
}

export enum TimePeriodTypeName {
  today = "Today",
  tomorrow = "Tomorrow",
  yesterday = "Yesterday",
  thisWeek = "This Week",
  lastWeek = "Last Week",
  thisMonth = "This Month",
  lastMonth = "Last Month",
  selectDate = "Select Date",
  fourWeeks = "4 Weeks",
  sixMonths = "6 Months",
  custom = "Custom Period",
  noEndDate = "No End Date"
}

export enum CurrentToPriorKeysMatch {
  today = "yesterday",
  thisWeek = "lastWeek",
  lastWeek = "previousWeek",
  thisMonth = "lastMonth",
  lastMonth = "previousMonth",
  custom = "custom"
}

export enum CurrentToPriorNamesMatch {
  today = "Yesterday",
  thisWeek = "Last Week",
  lastWeek = "Previous Week",
  thisMonth = "Last Month",
  lastMonth = "Previous Month",
  custom = "Prior Period"
}

export interface ITimePeriodFilter {
  startDate: Date;
  endDate: Date;
  previousStartDate: Date;
  previousEndDate: Date;
  selectedPeriod: TimePeriodType;
  comparisonType: TimePeriodComparisonType
}

export interface ITimePeriodFilterOptions {
  startDate: string;
  endDate: string;
  previousStartDate: string;
  previousEndDate: string;
}

export const enum PartialMatch {
  lastWeek = "partialLastWeek",
  lastMonth = "partialLastMonth"
}